<template>
    <div class="menu-sidebar">
        <div class="menu-sidebar--main">
            <a class="u-reset menu-sidebar--link" :href="mapLink">
                {{ 'HOME_OVERLAY.CTA_LABEL' | translate }}
            </a>
            <snake-pattern class="menu-sidebar--snake-pattern"/>
            <a class="u-reset menu-sidebar--link" :href="activeRootCategory.url">
                {{ 'HOME_OVERLAY.SECONDARY_ACTION_LABEL' | translate }}
            </a>
            <snake-pattern class="menu-sidebar--snake-pattern"/>
            <a class="u-reset menu-sidebar--link" :href="translate('CMS.USAGE.URL')">
                {{ 'CMS.USAGE.TITLE' | translate }}
            </a>
        </div>
        <div class="menu-sidebar--footer">
            <div class="menu-sidebar--footer-items">
                <div class="menu-sidebar--footer-item">
                    <a :href="translate('CMS.IMPRINT.URL')"
                            class="u-reset menu-sidebar--link menu-sidebar--link__footer">
                        {{ 'CMS.IMPRINT.TITLE' | translate }}
                    </a>
                </div>
                <div class="menu-sidebar--footer-item">
                    <a :href="translate('MENU_SIDEBAR.FOOTER.BUX_APP.URL')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="u-reset menu-sidebar--link menu-sidebar--link__footer">
                        {{ 'MENU_SIDEBAR.FOOTER.BUX_APP.TITLE' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import { mapFilters } from 'util/vue/map-filters';
    import SnakePattern from 'framework/global-components/snake-pattern/snake-pattern';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { MAP_APP_RECORD_NAMES } from 'framework/router/route-data-configs';

    export default {
        components: {
            SnakePattern,
        },
        mixins: [
            bemMixin('menu-sidebar'),
        ],
        computed: {
            ...mapGetters('project-data', ['activeRootCategory']),
            mapLink() {
                return this.resolveRoute(MAP_APP_RECORD_NAMES.MAP).fullPath;
            },
        },
        methods: {
            ...mapFilters(['translate']),
            ...mapActions('project-status', ['toggleMenuSidebar']),
            resolveRoute(name) {
                return this.$router.resolve({ name }).resolved;
            },
        },
        beforeDestroy() {
            this.toggleMenuSidebar({ open: false });
        },
    };
</script>
